import React from 'react';
import {Button, Icons} from '@xpertdox_js/xdcomponents'
import {absCenter, clearfix, colors} from '@xpertdox_js/xdstyle';
import { trackActivity } from '../../utils/activityTracker'
import { UserContext } from '../../Context/UserContext'
import { InstanceContext } from '../../InstanceContext'

const styles = {
  container: {
    marginBottom: '24px',
  },
  trialContainer: {
    ...clearfix,
    width: '100%',
    maxWidth: '400px',
    background: '#fff',
    border: '1px solid rgba(0,0,0,0.15)',
    display: 'inline-block',
    position: 'relative',
    borderRadius: '4px',
    verticalAlign: 'top',
    marginRight: '5px',
    marginBottom: '5px'
  },
  button: {
    position: 'absolute',
    left: 'auto',
    right: 0,
    top: 0,
    bottom: 0,
    padding: '5px 0',
    height: '100%',
    width: '20%',
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
    background: colors.offWhite,
    borderLeft: '1px solid rgba(0,0,0,0.15)',
    fill: '#aaa',
  },
  buttonHov: {
    fill: colors.error,
  },
  trialContent: {
    width: '80%',
    padding: '4px',
    float: 'left',
  },
  svg: {
    ...absCenter,
    display: 'block',
    color: '#000',
    width: '25px',
    height: '25px'
  },
  title: {
    fontSize: '1.2rem',
    margin: '5px 0 0',
  },
  id: {
    fontSize: '1rem'
  }
}

const TrialDisplay = props => {
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)
  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  return <div style={styles.container}>
  {props.selection.map((trial, i) => (
    <div key={i} style={styles.trialContainer}>
      <div style={styles.trialContent}>
        <span style={styles.id}>{trial._id}</span>
        <h5 style={styles.title}>{trial._source.title1}</h5>
      </div>
      <Button
        styles={styles.button}
        hoverStyles={styles.buttonHov}
        onClick={() => {props.removeTrial();handleActivityLogUpdate(`TrialDisplay.handleActivityLogUpdate`)}}
        clickParam={trial}
      >
        <Icons icon='x' style={styles.svg} />
      </Button>
    </div>
  ))}
  </div>
}

export default TrialDisplay;
